import React, { useEffect, useState } from "react";
import { Container, Nav } from "react-bootstrap";
import { Outlet, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { WALLET_MENU_DATA, TENANT_BUCKET } from '../../common/constants';
import { useStoreDispatch, useStoreState, APP_STORE_ACTION } from '../../common/storeContext';
import { useMiddletier } from "../../common/middletier";
import Loading from '../../components/Loading';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { FaArrowRotateLeft } from "react-icons/fa6";

import "./template_01.css";


const WalletBar = (props) => {
  const appDispatch = useStoreDispatch()
  const appState = useStoreState()
  const navigate = useNavigate();
  const { queries, mutation } = useMiddletier();
  const [affiliateGroupImage, setAffiliateGroupImage] = useState(``);
  const { t } = useTranslation();
  const [isLoading, setLoading] = useState(false);

  // LOGOUT
  const onSubmitLogout = () => {
    mutation([
      {
        method: 'logout',
        params: [],
        attributes: []
      }
    ])
      .then(({ data }) => {
        appDispatch({ type: APP_STORE_ACTION.LOGOUT })
        navigate('/')
      })
      .catch((error) => {
        console.error('error: ', error)
        appDispatch({ type: APP_STORE_ACTION.LOGOUT })
        navigate('/')
      })
  }


  // GET AFFILIATE GROUP
  useEffect(() => {

    queries([{
      method: 'getAffiliateGroup',
      params: [
        { code: 'filter', graphqlType: 'JSON', required: true, value: { where: { id: appState.user?.affiliate_group ?? 'DEFAULT' } } }
      ],
      attributes: [['_logo', ['url']]]

    }]).then(({ data }) => {

      setAffiliateGroupImage(data['getAffiliateGroup']?.[0]?._logo ? data['getAffiliateGroup']?.[0]?._logo.url : `${TENANT_BUCKET}/icon/wallet_user.png`)

    }).catch((error) => {
      console.log('error: ', error)
      if (error?.networkError?.statusCode === 401) {
        appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
      } else {
        appDispatch({
          type: APP_STORE_ACTION.SHOW_ALERT,
          payload: { description: error.message.toString(), typeAlert: 'error' }
        });
      }
    })

  }, [appState.user, queries, navigate, appDispatch]);



  return (
    <>
      <Nav variant="pills" className="walletBar">
        <div className="walletBar_Info">
          <div className="walletBar_userInfo">
            {affiliateGroupImage && (<img src={`${affiliateGroupImage}`} alt={'wallet user'} />)}
            <div>
              <span className="d-block">{(t("welcome"))}</span>
              <span className="walletBar_userName">{appState.user?.username}</span>
            </div>
          </div>

        </div>
        <Nav.Item>
          {Object.keys(WALLET_MENU_DATA).map((key, index) => {
            return (
              <div key={index}>
                <div className="font_h3 walletBar_title">{(t(key))}</div>
                {WALLET_MENU_DATA[key].map(function (item, index) {
                  return (
                    <NavLink to={`${item.url}`} key={item.id}>
                      {({ isActive }) => (
                        <span className={`walletBar_selection ${isActive && 'color_active active'}`}>
                          <img src={isActive ? item.selectedIcon : item.icon} alt={'wallet bar icon'} />
                          {(t(item.name))}
                        </span>
                      )}
                    </NavLink>
                  )
                })}
              </div>
            )
          })
          }
        </Nav.Item>
        <button className="font_button color_button walletBar_btnLogout" onClick={onSubmitLogout}>
          {t('logout')}
        </button>
      </Nav>
      {isLoading && (<Loading />)}
    </>
  )
}

const WalletAmountBar = () => {
  const appDispatch = useStoreDispatch()
  const appState = useStoreState()
  const { query } = useMiddletier()
  const { t } = useTranslation();
  const [isLoading, setLoading] = useState(false);
  const [showBalance, setShowBalance] = useState(false);
  const [showBalanceDeposit, setShowBalanceDeposit] = useState(false);


  const onClickRefreshBalance = () => {
    setLoading(true)
    const method = 'getAffiliate'

    query({
      method,
      params: [
        { code: 'filter', graphqlType: 'JSON', required: true, value: { where: { username: appState.user.username } } }
      ],
      attributes: ['main_wallet_amount','deposit_wallet_amount']

    }).then(({ data }) => {
      appDispatch({ type: APP_STORE_ACTION.REFRESH_MAIN_WALLET_AMOUNT, payload: data[method]?.[0]?.main_wallet_amount })
      appDispatch({ type: APP_STORE_ACTION.REFRESH_DEPOSIT_WALLET_AMOUNT, payload: data[method]?.[0]?.deposit_wallet_amount })
      setLoading(false)

    }).catch((error) => {
      console.log('error: ', error)
      if (error?.networkError?.statusCode === 401) {
        appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
      } else {
        appDispatch({
          type: APP_STORE_ACTION.SHOW_ALERT,
          payload: { description: error.message.toString(), typeAlert: 'error' }
        });
      }
    })
  }

  const formatAmount = (amount, decimalPoint) => {
    const factor = Math.pow(10, decimalPoint);
    const truncatedAmount = Math.floor(amount * factor) / factor;
    const formattedAmount = truncatedAmount.toLocaleString(appState.currencyFormat?.locale, {
      minimumFractionDigits: decimalPoint,
      maximumFractionDigits: decimalPoint,
    });
    return formattedAmount;
  }
  return (
    <>
      <Nav variant="pills" className="walletAmountBar">
        <div className="walletAmountBar_Info">
          <div className="walletAmountBar_walletInfo">
            <div className="walletAmountBar_walletTitle">
              {(t("deposit_amount"))}<span className="color_active"> ({appState.user?.currency ?? appState?.currency})</span>
            </div>
            <div className="walletAmountBar_walletBalance">
              <div className="walletAmountBar_balanceCurrency">{appState.user?.currency ?? appState?.currency} </div>
              <div className="walletAmountBar_balanceAmount"> <span> {!showBalanceDeposit ? formatAmount(appState.user?.deposit_wallet_amount ?? 0, appState.currencyFormat.decimal_point) : '**********'}</span>
              </div>
              <div className="walletAmountBar_walletIcon">
                {!showBalanceDeposit ? <FaEye onClick={() => setShowBalanceDeposit(!showBalanceDeposit)} /> : <FaEyeSlash onClick={() => setShowBalanceDeposit(!showBalanceDeposit)} />}
                <FaArrowRotateLeft onClick={() => onClickRefreshBalance()} />

              </div>
            </div>
          </div>
          <div className="walletAmountBar_walletInfo">
            <div className="walletAmountBar_walletTitle">
              {(t("main_wallet_balance"))}<span className="color_active"> ({appState.user?.currency ?? appState?.currency})</span>
            </div>
            <div className="walletAmountBar_walletBalance">
              <div className="walletAmountBar_balanceCurrency">{appState.user?.currency ?? appState?.currency} </div>
              <div className="walletAmountBar_balanceAmount"> <span> {!showBalance ? formatAmount(appState.user?.main_wallet_amount ?? 0, appState.currencyFormat.decimal_point) : '**********'}</span>

              </div>
              <div className="walletAmountBar_walletIcon">
                {!showBalance ? <FaEye onClick={() => setShowBalance(!showBalance)} /> : <FaEyeSlash onClick={() => setShowBalance(!showBalance)} />}
                <FaArrowRotateLeft onClick={() => onClickRefreshBalance()} />

              </div>
            </div>
          </div>
        </div>
      </Nav>
      {isLoading && (<Loading />)}
    </>
  )
}

const Wallet = (props) => {
  const { reminderToggle } = props
  const appDispatch = useStoreDispatch()
  const appState = useStoreState()
  const location = useLocation()
  const [isLoading, setLoading] = useState(false);
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 992px)'
  })
  const { mutation } = useMiddletier();
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])


  useEffect(() => {

    if (appState.loggedIn === false) {
      // setLoading(true)
      if (appState.loginWithToken === true) {
        setLoading(false)
        mutation([
          {
            index: 'loginWithTokenByAffiliate',
            method: 'loginWithTokenByAffiliate',
            params: [],
            attributes: []
          }
        ])
          .then(({ data }) => {
            // console.log('login token')
            setLoading(false)
            // console.log('data: ', data['loginWithTokenByAffiliate'])
            appDispatch({ type: APP_STORE_ACTION.LOGIN, payload: { ...data['loginWithTokenByAffiliate'] } })

          })
          .catch((error) => {
            // console.log('login error')
            setLoading(false)
            console.error(error)
            appDispatch({ type: APP_STORE_ACTION.SET_LOGIN_WITH_TOKEN, payload: false })
            if (error?.networkError?.statusCode === 401) {
              appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
            } else {
              appDispatch({
                type: APP_STORE_ACTION.SHOW_ALERT,
                payload: { description: error.message.toString(), typeAlert: 'error' }
              });
            }
          })
      } else {
        // console.log('login false')
        setLoading(false)
        appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
      }
    } else {
      // console.log('login true')
      setLoading(false)
    }
  }, [mutation, appDispatch, appState, navigate])


  return (

    <>
      <section id='wallet_01'>
        <div className="wallet_body">
          <Container className={`wallet_body_container ${!isDesktopOrLaptop ? 'wallet_body_container_m' : ''}`}>
            {isDesktopOrLaptop && <WalletBar />}
            <div className={`wallet_container ${!isDesktopOrLaptop ? 'wallet_container_m' : ''}`}>
              {isDesktopOrLaptop && <WalletAmountBar />}
              <Outlet context={{ reminderToggle: reminderToggle }} />
            </div>
          </Container>
        </div>
      </section>
      {isLoading && (<Loading />)}
      {/* <Alert show={alertShow.show} onHide={onHideAlert} message={alertShow.message} type={alertShow.type} title={alertShow.title} /> */}
    </>
  );
}

export default Wallet;
